const userRoutes = [
  {
    path: '/user/dashboard',
    name: 'user.dashboard',
    component: () => import('../views/user/Dashboard.vue'),
  },
  {
    path: '/user/listagem-mensagens',
    name: 'user.listagemMensagens',
    component: () => import('../views/user/ListaMensagensUsuario.vue'),
  },
  {
    path: '/user/atualiza-senha',
    name: 'user.atualizaSenha',
    component: () => import('../views/user/AtualizaSenha.vue'),
  },
  {
    path: '/user/acesso-sistema',
    name: 'user.acessoSistema',
    component: () => import('../views/user/AcessoSistema.vue'),
  },
  {
    path: '/user/pedido-acesso',
    name: 'user.pedidoAcesso',
    component: () => import('../views/user/ModalPedidoAcesso.vue'),
  },
];

export default userRoutes;
